import React from "react";
import { NavLink } from "react-router-dom";
import { setBlurOff, setNavOff } from "../../store/slices/hostSlices";
import { useDispatch, useSelector } from "react-redux";
import { getFlags } from "../../store/thunks/hostActions";

const SideNavLink = ({ icon: IconComponent, label, link }) => {
    const { hostInfo } = useSelector((state) => state.host);
    const dispatch = useDispatch();

    return (
        <NavLink
            to={`/${link}`}
            onClick={() => {
                dispatch(setNavOff());
                dispatch(setBlurOff());
                dispatch(getFlags(hostInfo._id));
            }}
            className={({ isActive }) =>
                `flex items-center gap-3 px-3.5 py-2.5 rounded-xl transition-all duration-200 group ${
                    isActive
                        ? "bg-primary-50 text-gray-900"
                        : "text-gray-500 hover:text-gray-800 hover:bg-gray-50"
                }`
            }
        >
            {({ isActive }) => (
                <>
                    <div
                        className={`w-8 h-8 rounded-lg flex items-center justify-center transition-all duration-200 ${
                            isActive
                                ? "bg-primary-500 text-white shadow-sm"
                                : "bg-gray-100 text-gray-400 group-hover:bg-gray-200 group-hover:text-gray-600"
                        }`}
                    >
                        {typeof IconComponent === "string" ? (
                            <img src={IconComponent} alt="" className="w-4 h-4" />
                        ) : (
                            <IconComponent size={16} strokeWidth={2} />
                        )}
                    </div>
                    <span className={`text-[13px] ${isActive ? "font-semibold" : "font-medium"}`}>
                        {label}
                    </span>
                </>
            )}
        </NavLink>
    );
};

export default SideNavLink;
